import axios from "axios";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "./../Config/Config";
export const getFirstPageData = async (product) => {
     const userDetails = localStorage.getItem("userDetail");
    const temp = JSON.parse(userDetails);
    const Response = await axios
        .get(
            `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getPageElements&companyid=${temp.companyid}&productid=${product}`
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error.response.data.error);
        });
    return Response;
    }

    export const getTreeStructurePageData = async (product) => {
        const userDetails = localStorage.getItem("userDetail");
       const temp = JSON.parse(userDetails);
       const Response = await axios
           .get(
               `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getPages&companyid=${temp.companyid}&productid=${product}`
               )
           .then((response) => {
               return response;
           })
           .catch((error) => {
               console.log(error.response.data.error);
           });
       return Response;
}

export const getSSPageData = async (ssid,product) => {
    const userDetails = localStorage.getItem("userDetail");
   const temp = JSON.parse(userDetails);
   const Response = await axios
       .get(
           `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getPageSS&companyid=${temp.companyid}&pageid=${ssid}&prodid=${product}`
       )
        .then((response) => {
           return response;
       })
       .catch((error) => {
           console.log(error.response.data.error);
       });
   return Response;
}